import "./componentsStyle.scss";
import { BoatImg } from "../assets/photos";
import {
  whyUsDescription,
  whyUsLable,
  whyUsTitle,
} from "../constants/translations";
import { PrimaryButton } from "./PrimaryButton";
import { LocSvg, PeopleSvg, SecuritySvg } from "../assets/svg";

export const WhyUS = ({ languageId }) => {
  return (
    <div className="whyUsContainer">
      <div className="descrition">
        <div className="label">{whyUsLable[languageId]?.label}</div>
        <div className="title">{whyUsTitle[languageId].label}</div>
        <div className="des">{whyUsDescription[languageId].label}</div>
        <div className="icons">
          <div className="icon">
            <PeopleSvg width={50} height={50} />
            <span>Local Guides</span>
          </div>
          <div className="icon">
            <LocSvg width={50} height={50} />
            <span>Authentic Experiences</span>
          </div>
          <div className="icon">
            <SecuritySvg width={50} height={50} />
            <span>Best Price Guarantee</span>
          </div>
        </div>
        {/* <div className="button">
          <PrimaryButton type="primary" label="Book Now" />
        </div> */}
      </div>
      <div className="imgContainer">
        <img src={BoatImg} alt="boat" className="boatImg" />
      </div>
    </div>
  );
};
